var _vars = require('./vars')._vars;
// Legacy wording — used by the standalone full-width /ai-search page.
const AI_DISCLAIMER_PREFIX_DESKTOP = 'Medscape AI';
const AI_DISCLAIMER_PREFIX_MOBILE = 'This tool';
const AI_DISCLAIMER_SUFFIX = ' is intended for educational purposes only. Please consult official clinical guidelines for diagnosis or treatment.';
const AI_DISCLAIMER_LINK_TEXT = 'Medscape AI Disclaimer';
const AI_DISCLAIMER_SHORT = 'Medscape AI is intended for educational purposes.';

// Rebranded wording — used by the AI modal layer (news, conditions, drugs pages).
const AI_DISCLAIMER_PREFIX_MODAL = 'This tool';
const AI_DISCLAIMER_SUFFIX_MODAL = ' is intended for educational purposes only. Please consult official guidelines for diagnosis or treatment.';
const AI_DISCLAIMER_LINK_TEXT_MODAL = 'AI Disclaimer';
const AI_DISCLAIMER_SHORT_MODAL = 'This AI tool is intended for educational purposes.';

const getAiDisclaimerUrl = () => `https://reference.${_vars.friendlyEnv}medscape.com/public/ai_search-disclaimer`;

const stripTags = function(str) {
	var template = document.createElement('template');
	template.innerHTML = String(str);
	return template.content.textContent || '';
};

const _html = {
	main: function() { return `
			<div id="ai-search-modal">
				<div class="ai-search-header">
					<div class="ai-search-logo">` + _html.brandLogo() + `</div>
					<div class="close-layer"></div>
				</div>
				<div class="ai-search-content">
					<div class="ai-search-prompts">`

			+ _html.hardcodedQuestions(_vars.cfg.hardcoded) +

			`</div>
					<div class="ai-search-progress">
					<div class="progress-text-a"></div>
					<div class="dot-flashing"></div>
					</div>
					<div class="ai-search-asking">
						<div class="ai-search-progress">
						<div class="progress-text-a"></div>
						<div class="dot-flashing"></div>
						</div>						
						<div class="ai-search-stop">
							<p>Sorry, this is taking longer than usual. You can continue waiting or tap below to start a new conversation.</p>
							<div class="ai-search-stop-btn">Stop generating</div>
						</div>
						<div class="ai-search-new">
							<div class="ai-search-new-btn" onclick="wmdPageLink('ai-search_new-topic', this);">
								<span>Start new search</span>
							</div>
						</div>
						<div class="ai-search-instructions">
							<p>AI Search delivers precise responses and direct links for deeper insights from medical and academic sources.</p>
						</div>
					</div>
				</div>
				<div class="ai-search-footer">
					<div id="feedbackSuccessMsg">
						<p>Thank you for providing your feedback!</p>
					</div>
					<div class="ai-search-prompts">
						<ul class="prompts-desktop-modal"></ul>
						<ul class="prompts-mobile-modal"></ul>
					</div>
					<div name="ai-search-field-modal" id="ai-search-field-modal">
						<textarea id="ai-search-input-modal" name="ai-search-input-modal" autocomplete="off" placeholder="Ask anything" rows="1"></textarea>
						<div id="ai-search-modal-submit" role="button" aria-label="Button to Search"></div>
						<div class="ai-search-stop-btn-dify">
							<div>
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">					<path fill-rule="evenodd" clip-rule="evenodd" d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 15.403 22.5825 18.4762 20.3078 20.6592C18.1524 22.7276 15.224 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="#064AA7"></path>
									<path d="M8.5625 16.0625C8.21732 16.0625 7.9375 15.7827 7.9375 15.4375L7.9375 8.5625C7.9375 8.21732 8.21732 7.9375 8.5625 7.9375L15.4375 7.9375C15.7827 7.9375 16.0625 8.21732 16.0625 8.5625V15.4375C16.0625 15.7827 15.7827 16.0625 15.4375 16.0625H8.5625Z" fill="white"></path>
								</svg>
							</div>
						</div>
					</div>
					<div class="ai-search-more"><span>More</span></div>
					<div class="ai-search-open-link">
					<a href= "https://www.`+ _vars.friendlyEnv + `medscape.com/ai-search" target="_blank" class="full-search-link">
					Start a new conversation 
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M0 0.874939C0 0.391691 0.39175 -6.10352e-05 0.875 -6.10352e-05H4.8125C5.05412 -6.10352e-05 5.25 0.195814 5.25 0.437439C5.25 0.679064 5.05412 0.874939 4.8125 0.874939L0.875 0.874939V13.1249H13.125V9.18744C13.125 8.94581 13.3209 8.74994 13.5625 8.74994C13.8041 8.74994 14 8.94581 14 9.18744V13.1249C14 13.6082 13.6082 13.9999 13.125 13.9999H0.875C0.391751 13.9999 0 13.6082 0 13.1249V0.874939ZM7.43752 0.437439C7.43752 0.195814 7.63339 -6.10352e-05 7.87502 -6.10352e-05H13.5625C13.8041 -6.10352e-05 14 0.195814 14 0.437439V6.12496C14 6.36658 13.8041 6.56246 13.5625 6.56246C13.3209 6.56246 13.125 6.36658 13.125 6.12496V1.49366L5.12186 9.4968C4.951 9.66765 4.674 9.66765 4.50314 9.4968C4.33229 9.32594 4.33229 9.04893 4.50314 8.87808L12.5063 0.874939H7.87502C7.63339 0.874939 7.43752 0.679064 7.43752 0.437439Z" fill="#064AA7"/>
					</svg>
					</a>
					<div class="ai-search-disclaimer">
					AI may make mistakes. Always apply your clinical judgment.
					</div>
					</div>
					<div id="feedbackDrawer" class="drawer">
						<div class="drawer-content">
							<span class="drawer-close-btn"></span>
							<h3>Medscape AI Feedback</h3>
							<p>Please select the reason(s) for your feedback:</p>
							<form id="feedbackForm" class="feedback-checkbox-group">
								<label class="feedback-option">Factual inaccuracy <input type="checkbox" name="reason" value="Factual inaccuracy"> 
									<span class="checkmark">
										<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path fill-rule="evenodd" clip-rule="evenodd" d="M15.8536 2.14643C16.0488 2.34169 16.0488 2.65828 15.8536 2.85354L5.20711 13.5C4.81658 13.8905 4.18342 13.8905 3.79289 13.5L0.146447 9.85354C-0.0488155 9.65828 -0.0488155 9.34169 0.146447 9.14643C0.341709 8.95117 0.658291 8.95117 0.853553 9.14643L4.5 12.7929L15.1464 2.14643C15.3417 1.95117 15.6583 1.95117 15.8536 2.14643Z" fill="#064AA7"/>
										</svg>
									</span>
								</label>
								<label class="feedback-option">Omitted key information <input type="checkbox" name="reason" value="Omitted key information">
									<span class="checkmark">
										<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path fill-rule="evenodd" clip-rule="evenodd" d="M15.8536 2.14643C16.0488 2.34169 16.0488 2.65828 15.8536 2.85354L5.20711 13.5C4.81658 13.8905 4.18342 13.8905 3.79289 13.5L0.146447 9.85354C-0.0488155 9.65828 -0.0488155 9.34169 0.146447 9.14643C0.341709 8.95117 0.658291 8.95117 0.853553 9.14643L4.5 12.7929L15.1464 2.14643C15.3417 1.95117 15.6583 1.95117 15.8536 2.14643Z" fill="#064AA7"/>
										</svg>
									</span>
								</label>
								<label class="feedback-option">Included unnecessary detail <input type="checkbox" name="reason" value="Included unnecessary detail">
									<span class="checkmark">
										<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path fill-rule="evenodd" clip-rule="evenodd" d="M15.8536 2.14643C16.0488 2.34169 16.0488 2.65828 15.8536 2.85354L5.20711 13.5C4.81658 13.8905 4.18342 13.8905 3.79289 13.5L0.146447 9.85354C-0.0488155 9.65828 -0.0488155 9.34169 0.146447 9.14643C0.341709 8.95117 0.658291 8.95117 0.853553 9.14643L4.5 12.7929L15.1464 2.14643C15.3417 1.95117 15.6583 1.95117 15.8536 2.14643Z" fill="#064AA7"/>
										</svg>
									</span>
								</label>
								<label class="feedback-option">Misinterpreted question <input type="checkbox" name="reason" value="Misinterpreted question">
									<span class="checkmark">
										<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path fill-rule="evenodd" clip-rule="evenodd" d="M15.8536 2.14643C16.0488 2.34169 16.0488 2.65828 15.8536 2.85354L5.20711 13.5C4.81658 13.8905 4.18342 13.8905 3.79289 13.5L0.146447 9.85354C-0.0488155 9.65828 -0.0488155 9.34169 0.146447 9.14643C0.341709 8.95117 0.658291 8.95117 0.853553 9.14643L4.5 12.7929L15.1464 2.14643C15.3417 1.95117 15.6583 1.95117 15.8536 2.14643Z" fill="#064AA7"/>
										</svg>
									</span>
								</label>
								<label class="feedback-option">Oversimplified information <input type="checkbox" name="reason" value="Oversimplified information">
									<span class="checkmark">
										<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path fill-rule="evenodd" clip-rule="evenodd" d="M15.8536 2.14643C16.0488 2.34169 16.0488 2.65828 15.8536 2.85354L5.20711 13.5C4.81658 13.8905 4.18342 13.8905 3.79289 13.5L0.146447 9.85354C-0.0488155 9.65828 -0.0488155 9.34169 0.146447 9.14643C0.341709 8.95117 0.658291 8.95117 0.853553 9.14643L4.5 12.7929L15.1464 2.14643C15.3417 1.95117 15.6583 1.95117 15.8536 2.14643Z" fill="#064AA7"/>
										</svg>
									</span>
								</label>
								<label class="feedback-option">Language/grammar issues <input type="checkbox" name="reason" value="Language/grammar issues">
									<span class="checkmark">
										<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path fill-rule="evenodd" clip-rule="evenodd" d="M15.8536 2.14643C16.0488 2.34169 16.0488 2.65828 15.8536 2.85354L5.20711 13.5C4.81658 13.8905 4.18342 13.8905 3.79289 13.5L0.146447 9.85354C-0.0488155 9.65828 -0.0488155 9.34169 0.146447 9.14643C0.341709 8.95117 0.658291 8.95117 0.853553 9.14643L4.5 12.7929L15.1464 2.14643C15.3417 1.95117 15.6583 1.95117 15.8536 2.14643Z" fill="#064AA7"/>
										</svg>
									</span>
								</label>
								<label class="feedback-option">Other <input type="checkbox" name="reason" value="Other" id="otherCheckbox">
									<span class="checkmark">
										<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path fill-rule="evenodd" clip-rule="evenodd" d="M15.8536 2.14643C16.0488 2.34169 16.0488 2.65828 15.8536 2.85354L5.20711 13.5C4.81658 13.8905 4.18342 13.8905 3.79289 13.5L0.146447 9.85354C-0.0488155 9.65828 -0.0488155 9.34169 0.146447 9.14643C0.341709 8.95117 0.658291 8.95117 0.853553 9.14643L4.5 12.7929L15.1464 2.14643C15.3417 1.95117 15.6583 1.95117 15.8536 2.14643Z" fill="#064AA7"/>
										</svg>
									</span>
								</label>
								<textarea id="otherText" rows="3" placeholder="Please provide additional details"></textarea>
								<button type="submit">Submit Feedback</button>
							</form>
						</div>
					</div>
				</div>
			</div>
	` },

	fab: function() { 
		return `<div id="ai-search-fab" class="active" onclick="wmdTrack('ai-search_fab-click', this); aiSchPageview(0);">
					<span>Ask a Question</span>
				</div>`
	},

	hardcodedQuestions: function(questionArr) {
		let outStr = '';
		questionArr.forEach(function(question, idx) {
			outStr += '<p onclick="wmdPageLink(\'ai-search_msg-submit-clkc-' + (idx + 1) + '\', this);">' + question + '</p>';
		});
		return outStr;
	},
	deepDivePrompts: function(linksArr) {
		let outStr = '';
		linksArr.forEach(function(link, idx) {
			outStr += '<p class="deep-dive-prompt" data-prompt="' + link.prompt + '" data-link-id="' + link.id + '" onclick="wmdPageLink(\'ai-search_deep-dive-clkc-' + (idx + 1) + '\', this);">' + link.prompt + '</p>';
		});
		return outStr;
	},

	askingQuestion: function(ques) {
		var safeQues = stripTags(ques).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
		return '<div class="' + (document.querySelector('.ai-search-question') == null ? 'ai-search-question' : 'ai-search-asking-question') + ' loading current active"><span>' + safeQues + '</span><div class="progress-spinner active"><div></div><div></div><div></div><div></div></div></div>';
	},

	showAnswer: function(answer, summaryBullets) {
		var keyPointsHtml = '';
		if (summaryBullets && Array.isArray(summaryBullets) && summaryBullets.length > 0) {
			keyPointsHtml = _html.keyPointsCard(summaryBullets);
		}
		return '<div class="ai-search-answer active"><div class="answer">' + keyPointsHtml + '<div class="answer-content">' + answer + '</div></div></div>';
	},

	showRating: function() { return '<div class="ai-search-rating"><span class="ai-search-like">Like</span> <span class="ai-search-dislike">Dislike</span> <span class="ai-search-copy" aria-label="Copy conversation">Copy</span></div>' },

	followUp: function(ques, idx) { return '<li onclick="wmdPageLink(\'ai-search_followup-' + (idx + 1) + '\', this)"><span>' + ques + '</span></li>'},

	relatedArt: function(relArts) { 
		let outStr = '';
		relArts.match(/\[[^\(]+\]\([^\[]+\)/g).forEach(function(relArt, idx) {
			var lnkTxt = relArt.match(/\[(.+)\]/)[1];
			var lnkUrl = relArt.match(/\((.+)\)/)[1];
			outStr += '<li><a onclick="wmdTrack(\'ai-search_sim-ar-click-' + (idx + 1) + '\', this);" href="' + lnkUrl + '" target="_blank">' + lnkTxt + '</a></li>';
		})

		return `<div class="ai-search-related">
			<p>Related articles you might find interesting:</p>
			<ul>`
			+ outStr +
			`</ul>
		</div>`
	},

	errorModal: function(message) {
		return `<div id="ai-search-error-modal" class="error-modal">
			<div class="error-modal-overlay">
				<div class="error-modal-content">
					<div class="error-modal-header">
						<div class="error-icon">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<circle cx="12" cy="12" r="10" fill="#EF4444"/>
								<path d="M15 9l-6 6m0-6l6 6" stroke="white" stroke-width="2" stroke-linecap="round"/>
							</svg>
						</div>
						<h3>Service Unavailable</h3>
						<span class="error-modal-close">&times;</span>
					</div>
					<div class="error-modal-body">
						<p>${message}</p>
					</div>
				</div>
			</div>
		</div>`
	},

	referencesHeading: function () {
		return `
		<div class="references-section" >
			<button type="button" class="references-heading-wrapper">
				<div class="references-heading">
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M2 1C2 0.447716 2.44771 0 3 0H13C13.5523 0 14 0.447716 14 1V15C14 15.5523 13.5523 16 13 16H3C2.44772 16 2 15.5523 2 15V1ZM4.5 1L3 1V12H13V1H9V5.86932C9 6.04511 8.90768 6.208 8.75685 6.2983C8.60602 6.38861 8.41885 6.39307 8.26389 6.31006L6.75 5.49905L5.23611 6.31006C5.08115 6.39307 4.89398 6.38861 4.74315 6.2983C4.59232 6.208 4.5 6.04511 4.5 5.86932V1ZM5.5 1V5.03423L6.51389 4.49108C6.66138 4.41206 6.83862 4.41206 6.98611 4.49108L8 5.03423V1H5.5ZM13 13H3V15H13V13Z" fill="#161B1D"/>
					</svg>

					<h3>References</h3>
				</div>
				<div class="references-heading-chevron">
					<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M3.93306 7.05806C4.17714 6.81398 4.57286 6.81398 4.81694 7.05806L10 12.2411L15.1831 7.05806C15.4271 6.81398 15.8229 6.81398 16.0669 7.05806C16.311 7.30214 16.311 7.69786 16.0669 7.94194L10.8839 13.125C10.3957 13.6132 9.60427 13.6132 9.11612 13.125L3.93306 7.94194C3.68898 7.69786 3.68898 7.30214 3.93306 7.05806Z" fill="#161B1D"/>
					</svg>
				</div>
			</button>
			<div class="reference-item-wrapper"></div>
		</div>`;
	},

referenceItem: function(displayNumber, sourceTitle, sourceUrl, metadataText) {
		return '<div class="reference-item" data-citation-number="' + displayNumber + '">' +
			'<a onclick="wmdPageLink(\'ai-search_ref-ar-click-' + displayNumber + '\', this);" href="' + sourceUrl + '" target="_blank">' +
			'<span class="citation-circle">' + displayNumber + '</span><span class="reference-title-text">' + sourceTitle + '</span></a>' +
			(metadataText ? '<div class="reference-meta">' + metadataText + '</div>' : '') +
			'</div>';
	},

articleSearchFab: function() { 
		return `<div id="article-ai-search-fab" class="article-ai-search-fab">
<div class="article-search-wrapper" style="display: none;">
<div class="article-search-container">
<div class="article-search-icon-left" role="button" aria-label="AI Search Sparkle">
<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.76167 11.1325C5.69964 10.9464 5.55363 10.8004 5.36755 10.7383L0.426101 9.09118C-0.142035 8.9018 -0.142033 8.09819 0.426102 7.90881L5.36755 6.26167C5.55363 6.19964 5.69964 6.05362 5.76167 5.86754L7.40882 0.926101C7.59819 0.357965 8.40181 0.357967 8.59119 0.926103L10.2383 5.86755C10.3004 6.05362 10.4464 6.19964 10.6325 6.26167L15.5739 7.90881C16.142 8.09819 16.142 8.90181 15.5739 9.09118L10.6325 10.7383C10.4464 10.8004 10.3004 10.9464 10.2383 11.1325L8.59119 16.0739C8.40181 16.642 7.59819 16.642 7.40881 16.0739L5.76167 11.1325Z" fill="url(#paint0_linear_4215_4273)"/>
<defs>
<linearGradient id="paint0_linear_4215_4273" x1="2.5" y1="13.75" x2="10.5" y2="6" gradientUnits="userSpaceOnUse">
<stop stop-color="#006AFF"/>
<stop offset="1" stop-color="#F600FF"/>
</linearGradient>
</defs>
</svg>
</div>
<input type="text" id="article-search-bar" class="article-search-bar" placeholder="Ask anything" autocomplete="off">
<div class="article-search-icon-right" role="button" aria-label="Send search query">
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 15.403 22.5825 18.4762 20.3078 20.6592C18.1524 22.7276 15.224 24 12 24C5.37258 24 0 18.6274 0 12ZM8.06056 10.8108C7.78538 11.1204 7.31132 11.1482 7.00173 10.8731C6.69215 10.5979 6.66426 10.1238 6.93945 9.81423L11.4395 4.75173C11.5818 4.59161 11.7858 4.5 12 4.5C12.2142 4.5 12.4182 4.59161 12.5606 4.75173L17.0606 9.81423C17.3358 10.1238 17.3079 10.5979 16.9983 10.8731C16.6887 11.1482 16.2146 11.1204 15.9395 10.8108L12.75 7.22265V18.75C12.75 19.1642 12.4142 19.5 12 19.5C11.5858 19.5 11.25 19.1642 11.25 18.75V7.22265L8.06056 10.8108Z" fill="#064AA7"/>
</svg>
</div>
</div>
<div class="article-search-close" role="button" aria-label="Close article AI search">
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.69669 6.69671C6.98959 6.40381 7.46446 6.40381 7.75735 6.6967L12 10.9393L16.2426 6.69666C16.5355 6.40377 17.0104 6.40377 17.3033 6.69666C17.5962 6.98956 17.5962 7.46443 17.3033 7.75732L13.0606 12L17.3033 16.2426C17.5962 16.5355 17.5962 17.0104 17.3033 17.3033C17.0104 17.5962 16.5355 17.5962 16.2426 17.3033L12 13.0606L7.75732 17.3033C7.46443 17.5962 6.98956 17.5962 6.69666 17.3033C6.40377 17.0104 6.40377 16.5355 6.69666 16.2426L10.9393 12L6.69669 7.75736C6.4038 7.46447 6.4038 6.9896 6.69669 6.69671Z" fill="#435056"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C14.8216 22.5 17.3819 21.3881 19.2692 19.5769C21.2614 17.6651 22.5 14.9778 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 15.403 22.5825 18.4762 20.3078 20.6592C18.1524 22.7276 15.224 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="#435056"/>
</svg>
</div>
</div>
<div class="article-search-sparkle" role="button" aria-label="Show article AI search">
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.5233 21.2649C11.3993 20.8927 11.1073 20.6007 10.7351 20.4767L0.852203 17.1824C-0.284069 16.8036 -0.284067 15.1964 0.852205 14.8176L10.7351 11.5233C11.1073 11.3993 11.3993 11.1072 11.5233 10.7351L14.8176 0.852202C15.1964 -0.284069 16.8036 -0.284066 17.1824 0.852205L20.4767 10.7351C20.6007 11.1072 20.8928 11.3993 21.2649 11.5233L31.1478 14.8176C32.2841 15.1964 32.2841 16.8036 31.1478 17.1824L21.2649 20.4767C20.8928 20.6007 20.6007 20.8927 20.4767 21.2649L17.1824 31.1478C16.8036 32.2841 15.1964 32.2841 14.8176 31.1478L11.5233 21.2649Z" fill="url(#paint0_linear_4186_8367)"/>
<defs>
<linearGradient id="paint0_linear_4186_8367" x1="5" y1="26.5" x2="21" y2="11" gradientUnits="userSpaceOnUse">
<stop stop-color="#006AFF"/>
<stop offset="1" stop-color="#F600FF"/>
</linearGradient>
</defs>
</svg>
</div>
</div>`
	},

followUpQuestions: function(questions) {
		let questionsHtml = '';
questions.forEach(function(question, index) {
			questionsHtml += `<li class="follow-up-question-item" tabindex="0" role="button" aria-label="Follow-up question: ${question}" data-question="${question}">
<div class="follow-up-question-text">${question}</div>
<div class="follow-up-question-arrow">
<svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.39645 13.1036C5.20118 12.9083 5.20118 12.5917 5.39645 12.3964L9.54289 8.25L5.39645 4.10355C5.20118 3.90829 5.20118 3.59171 5.39645 3.39645C5.59171 3.20118 5.90829 3.20118 6.10355 3.39645L10.25 7.54289C10.6405 7.93342 10.6405 8.56658 10.25 8.95711L6.10355 13.1036C5.90829 13.2988 5.59171 13.2988 5.39645 13.1036Z" fill="#161B1D"/>
</svg>
</div>
</li>`;
		});

		return `<div class="follow-up-questions-section">
<div class="follow-up-questions-header">
<svg width="16" height="16" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 1C3.5 0.723858 3.72386 0.5 4 0.5H15.5C15.7761 0.5 16 0.723858 16 1C16 1.27614 15.7761 1.5 15.5 1.5H4C3.72386 1.5 3.5 1.27614 3.5 1ZM3.5 4.49998C3.5 4.22383 3.72386 3.99998 4 3.99998H15.5C15.7761 3.99998 16 4.22383 16 4.49998C16 4.77612 15.7761 4.99998 15.5 4.99998H4C3.72386 4.99998 3.5 4.77612 3.5 4.49998ZM3.5 8C3.5 7.72386 3.72386 7.5 4 7.5H15.5C15.7761 7.5 16 7.72386 16 8C16 8.27614 15.7761 8.5 15.5 8.5H4C3.72386 8.5 3.5 8.27614 3.5 8Z" fill="#161B1D"/>
<path d="M2 1C2 1.55228 1.55228 2 1 2C0.447715 2 0 1.55228 0 1C0 0.447715 0.447715 0 1 0C1.55228 0 2 0.447715 2 1Z" fill="#161B1D"/>
<path d="M2 4.5C2 5.05228 1.55228 5.5 1 5.5C0.447715 5.5 0 5.05228 0 4.5C0 3.94772 0.447715 3.5 1 3.5C1.55228 3.5 2 3.94772 2 4.5Z" fill="#161B1D"/>
<path d="M2 8C2 8.55229 1.55228 9 1 9C0.447715 9 0 8.55229 0 8C0 7.44772 0.447715 7 1 7C1.55228 7 2 7.44772 2 8Z" fill="#161B1D"/>
</svg>
<span class="follow-up-questions-title">Follow-up Questions</span>
</div>
<ul class="follow-up-questions-list">
${questionsHtml}
</ul>
</div>`;
	},

	// Helper function to format text with markdown-style formatting (bold and italic)
formatKeyPointText: function(text) {
		if (!text) return text;

		// Handle bold formatting **text** -> <b>text</b>
		text = text.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');

		// Handle italic formatting *text* -> <i>text</i> (but avoid already processed bold text)
    text = text.replace(/(?:^|[^*])\*([^*]+?)\*(?=[^*]|$)/g, function(match, content, offset, string) {
			// Check if this asterisk is part of a ** pair (already processed)
			var beforeChar = offset > 0 ? string[offset - 1] : '';
			var afterChar = offset + match.length < string.length ? string[offset + match.length] : '';

			// Only replace if it's not part of ** formatting
			if (beforeChar !== '*' && afterChar !== '*') {
				return match.replace(/\*([^*]+?)\*/, '<i>$1</i>');
			}
			return match;
		});

		return text;
	},

	keyPointsCard: function(bullets) {
	var bulletsHtml = bullets.map(function(bullet) {
			// Apply text formatting (bold/italic) to the bullet content
			var formattedBullet = _html.formatKeyPointText(bullet);
			return '<li class="key-points-bullet">' + formattedBullet + '</li>';
		}).join('');

		return `<div class="key-points-card expanded" data-expanded="true" id="key-points-card">
	<div class="key-points-header" role="button" tabindex="0" aria-expanded="true" aria-controls="key-points-content" onclick="window.toggleKeyPoints && window.toggleKeyPoints(this);">
	<div class="key-points-icon">
	<svg width="17" height="24" viewBox="0 0 17 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path fill-rule="evenodd" clip-rule="evenodd" d="M12.9328 12.4657C14.2184 11.2956 15 9.66594 15 7.875C15 4.41918 12.0444 1.5 8.25 1.5C4.45555 1.5 1.5 4.41918 1.5 7.875C1.5 9.66594 2.28162 11.2956 3.56719 12.4657C4.61112 13.4159 5.6935 14.7878 5.94541 16.5H10.5546C10.8065 14.7878 11.8889 13.4159 12.9328 12.4657ZM13.9425 13.575C12.8772 14.5447 12 15.8051 12 17.2456C12 17.6622 11.6622 18 11.2456 18H5.25442C4.83777 18 4.5 17.6622 4.5 17.2456C4.5 15.8051 3.62277 14.5447 2.55749 13.575C0.981821 12.1408 0 10.1173 0 7.875C0 3.52576 3.69365 0 8.25 0C12.8063 0 16.5 3.52576 16.5 7.875C16.5 10.1173 15.5182 12.1408 13.9425 13.575ZM4.5 20.25C4.5 19.8358 4.83579 19.5 5.25 19.5H11.25C11.6642 19.5 12 19.8358 12 20.25C12 20.6642 11.6642 21 11.25 21H5.25C4.83579 21 4.5 20.6642 4.5 20.25ZM6.75 22.5C6.33579 22.5 6 22.8358 6 23.25C6 23.6642 6.33579 24 6.75 24H9.75C10.1642 24 10.5 23.6642 10.5 23.25C10.5 22.8358 10.1642 22.5 9.75 22.5H6.75Z" fill="#161B1D"/>
	</svg>
	</div>
	<div class="key-points-title">Key Points</div>
	<div class="key-points-chevron">
	<svg class="chevron-down" width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: none;">
	<path fill-rule="evenodd" clip-rule="evenodd" d="M0.183058 0.183058C0.427136 -0.0610194 0.822864 -0.0610194 1.06694 0.183058L6.25 5.36612L11.4331 0.183058C11.6771 -0.0610194 12.0729 -0.0610194 12.3169 0.183058C12.561 0.427136 12.561 0.822864 12.3169 1.06694L7.13388 6.25C6.64573 6.73815 5.85427 6.73816 5.36612 6.25L0.183058 1.06694C-0.0610194 0.822864 -0.0610194 0.427136 0.183058 0.183058Z" fill="#161B1D"/>
	</svg>
	<svg class="chevron-up" width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path fill-rule="evenodd" clip-rule="evenodd" d="M0.183058 6.43306C0.427136 6.67714 0.822864 6.67714 1.06694 6.43306L6.25 1.25L11.4331 6.43306C11.6771 6.67714 12.0729 6.67714 12.3169 6.43306C12.561 6.18898 12.561 5.79326 12.3169 5.54918L7.13388 0.366119C6.64573 -0.122036 5.85427 -0.122037 5.36612 0.366119L0.183058 5.54918C-0.0610194 5.79326 -0.0610194 6.18898 0.183058 6.43306Z" fill="#161B1D"/>
	</svg>
	</div>
	</div>
	<div class="key-points-content" id="key-points-content" style="display: flex;">
	<ul class="key-points-list">
	${bulletsHtml}
	</ul>
	</div>
</div>`;
},

scrollableHeaderLayoutHeader:function(){
	return `
	<div class="ai-search-content-header">
		<div class="logo">
			<span>Medscape AI</span>
		</div>
	</div>	
	`
},

disclaimerBottomSheet: function(isModal) {
	const linkText = isModal ? AI_DISCLAIMER_LINK_TEXT_MODAL : AI_DISCLAIMER_LINK_TEXT;
	const prefix = isModal ? AI_DISCLAIMER_PREFIX_MODAL : AI_DISCLAIMER_PREFIX_MOBILE;
	const suffix = isModal ? AI_DISCLAIMER_SUFFIX_MODAL : AI_DISCLAIMER_SUFFIX;
	const disclaimerLink = `<a class="ai-disclaimer-bs-link" href="${getAiDisclaimerUrl()}" target="_blank" rel="noopener noreferrer">${linkText}</a>`;
	return `<div class="ai-disclaimer-bottom-sheet" role="dialog" aria-label="AI Disclaimer" aria-hidden="true">
		<div class="ai-disclaimer-bs-overlay"></div>
		<div class="ai-disclaimer-bs-panel">
			<button class="ai-disclaimer-bs-close" aria-label="Close disclaimer"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.146447 0.146447C0.341709 -0.0488155 0.658291 -0.0488155 0.853553 0.146447L8 7.29289L15.1464 0.146447C15.3417 -0.0488155 15.6583 -0.0488155 15.8536 0.146447C16.0488 0.341709 16.0488 0.658291 15.8536 0.853553L8.70711 8L15.8536 15.1464C16.0488 15.3417 16.0488 15.6583 15.8536 15.8536C15.6583 16.0488 15.3417 16.0488 15.1464 15.8536L8 8.70711L0.853553 15.8536C0.658291 16.0488 0.341709 16.0488 0.146447 15.8536C-0.0488155 15.6583 -0.0488155 15.3417 0.146447 15.1464L7.29289 8L0.146447 0.853553C-0.0488155 0.658291 -0.0488155 0.341709 0.146447 0.146447Z" fill="#161B1D"/></svg></button>
			<p class="ai-disclaimer-bs-text">${prefix}${suffix} ${disclaimerLink}</p>
		</div>
	</div>`;
},
brandLogo: function() {
	return `<span class="ai-brand-logo" role="img" aria-label="Medscape">` +
		`<span class="ai-brand-logo__mark"></span>` +
		`<span class="ai-brand-logo__emblem"></span>` +
		`</span>`;
},
disclaimerInlineHtml: function(isModal) {
	const linkText = isModal ? AI_DISCLAIMER_LINK_TEXT_MODAL : AI_DISCLAIMER_LINK_TEXT;
	const prefix = isModal ? AI_DISCLAIMER_PREFIX_MODAL : AI_DISCLAIMER_PREFIX_DESKTOP;
	const suffix = isModal ? AI_DISCLAIMER_SUFFIX_MODAL : AI_DISCLAIMER_SUFFIX;
	const shortText = isModal ? AI_DISCLAIMER_SHORT_MODAL : AI_DISCLAIMER_SHORT;
	const disclaimerLink = `<a href="${getAiDisclaimerUrl()}" target="_blank" rel="noopener noreferrer">${linkText}</a>`;
	return `<span class="ai-search-disclaimer-full">${prefix}${suffix} ${disclaimerLink}</span>` +
		`<span class="ai-search-disclaimer-short">${shortText} <a class="ai-search-see-more" href="#">See More</a></span>`;
}
}

module.exports = {
	_html: _html,
	stripTags: stripTags
};
